const contactForm = {
  page: {
    title: 'Contact IhreApotheken.de',
    description: 'For questions, comments, or requests to the IhreApotheken.de team, please use the contact form below. We look forward to your feedback and will take care of your concerns promptly.',
  },
  forms: {
    salutation: 'Salutation',
    firstName: 'First Name *',
    lastName: 'Last Name *',
    phoneNumber: 'Phone Number',
    email: 'Email Address *',
    message: 'Your Message *',
    ourPromise: '{strongText} We use your phone number only for possible queries from the pharmacy regarding your pre-orders. Additionally, you will be informed about the status of your order via SMS and email.',
    ourPromiseTitle: 'Our Promise',
    policy: {
      termsOfUse: 'Terms of Use',
      privacyPolicy: 'Privacy Policy',
      1: 'I have read and acknowledge the',
      2: 'and',
      3: ', and I agree to their terms.',
    },
    pleaseFill: '* Please fill out the required fields',
    send: 'Send',
  },
  success: {
    title: 'Contact Form',
    description: 'Thank you for your message to the IhrApotheken.de team. We have sent a copy of your message to the email address you provided.',
    button: 'Back to Home',
  },
  advantage: {
    title: 'Do you have questions for the pharmacy?',
    description: 'If you have questions about products or other health topics, you can contact the pharmacy team directly.',
    button: 'Contact now',
  },
}

export default contactForm
